export default __webpack_public_path__ + "static/favicon-7f1fb6f976030b69b8c4036d08da3522.png";